import lng from '../lang/lng';
import Storage from "./Storage";
import {format} from "./StringOperator";
import snippets from "./snippets";
import storage from "./Storage";

class Translate {
    static lang = Storage.getLanguage();
    static translations = Storage.getTranslates();

    static localNumber(number, to = false) {
        if (this.lang === 'fa' && to) {
            if (to === 'fa')
                return String(number).replace(/[0-9]/g, c => String.fromCharCode(c.charCodeAt(0) + 1728));
            else if (to === 'en')
                return String(number).replace(/[۰-۹]/g, c => String.fromCharCode(c.charCodeAt(0) - 1728));
        }
        return number;
    }

    static init2(label, lang = null ?? this.lang) {
        try {
            return lng[label][lang];
        } catch (e) {
            return label;
        }
    }

    static init(label, lang = null ?? this.lang) {
        try {
            return this.translations[label][lang];
        } catch {
            return this.init2(label, lang)
        }
    }

    static init3(label, lang = null) {
        return this.syncNumberWithLanguage(this.init(label, lang))
    }

    static init4(label, data = null,  lang = null ?? this.lang) {
        return this.syncNumberWithLanguage(format(this.init(label, lang), data))
    }

    static direction(state = null) {
        if (state !== null) {
            return state.direction === 'en' ? 'ltr' : 'rtl';
        } else {
            return Storage.getLanguage() === 'en' ? 'ltr' : 'rtl';
        }
    }

    static toFarsiNumber(n) {
        const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        try{
            return n
                .toString()
                .replace(/\d/g, x => farsiDigits[x]);
        } catch {
            return n
        }
    }

    static toEnglishNumber(n) {
        const farsiDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        try{
            return n
                .toString()
                .replace(/\d/g, x => farsiDigits[x]);
        } catch{
            return n
        }
    }

    static syncNumberWithLanguage(number, to = null) {
        to = to ?? this.lang
        if (to === 'fa')
            return this.toFarsiNumber(number);
        else if (to === 'en')
            return this.toEnglishNumber(number);
    }

    static datetime(date=null){
        let to = storage.getLanguage()
        return this.init3(snippets.datetime(date), to)
    }

    static datetime2time(date=null){
        let to = storage.getLanguage()
        return this.init3(snippets.datetime2time(date), to)
    }
}


export default Translate;